import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AiReport, AiUserPreferences } from '../models/ai-report.model';
import { AiReportsState, aiReportsInitialState } from './ai-reports-initial-state';

const aiReportsSlice = createSlice({
    name: 'aiReports',
    initialState: aiReportsInitialState,
    reducers: {
        setReports(state, { payload }: PayloadAction<AiReport[]>) {
            state.reports = payload;
        },
        setSelectedReportId(state, { payload }: PayloadAction<string | null>) {
            state.selectedReportId = payload;
        },
        setPreferences(state, { payload }: PayloadAction<AiUserPreferences | null>) {
            state.preferences = payload;
        },
        updateReport(state, { payload }: PayloadAction<AiReport>) {
            const idx = state.reports.findIndex(r => r.id === payload.id);
            if (idx !== -1) state.reports[idx] = payload;
        },
        setIsLoading(state, { payload }: PayloadAction<boolean>) {
            state.isLoading = payload;
        },
        setGenerationStartedAt(state, { payload }: PayloadAction<string | null>) {
            state.generationStartedAt = payload;
        },
    },
});

export const { setReports, setSelectedReportId, setPreferences, updateReport, setIsLoading, setGenerationStartedAt } = aiReportsSlice.actions;
export default aiReportsSlice.reducer;
